import { documentDirectory } from "../../utils/fileSystemCompat"
import React, { useEffect, useRef, useState } from 'react'
import { View } from 'react-native'
import { Image } from 'expo-image'
import * as FileSystem from 'expo-file-system'
import { eventEmitter } from '../../utils/functions.utils'
import { getConection } from '../appBar/context/HeaderContext'

export const SecondarySplash = ({ url, hideSecondarySplash }) => {
    const [image, setImage] = useState(url)
    console.log('🚀 ~ SecondarySplash ~ image:', image)
    const splashTimerRef = useRef(null)

    useEffect(() => {
        // const fetchImage = async () => {
        //     let image = await searchSplash(url)
        //     setImage(image)

        // }
        setSplashTimer()
        // fetchImage()
    }, [])

    const setSplashTimer = () => {
        splashTimerRef.current = setTimeout(() => {
            hideSecondarySplash()
        }, 3000)
    }
    if (!image) {
        return null
    }
    return (
        <View
            style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'white',
                opacity: 1,
                pointerEvents: 'none',
            }}
        >
            <Image
                style={{ width: '60%', aspectRatio: 1, justifyContent: 'center', alignSelf: 'center' }}
                source={image}
                contentFit='contain'
                transition={1000}
                cachePolicy={'memory-disk'}
            />
        </View>
    )
}
export const getSplashName = (url: string) => {
    const parts = url.split('/')
    const lastPart = parts.pop()
    if (lastPart) {
        return lastPart.split('?')[0]
    }
    return null
}

export const searchSplashInFile = async (fileName: string, path: string) => {
    if (!fileName || fileName === '') {
        return false
    }
    //Agregar path por parametro => ej: unzipped/splash

    const directoryUri = `${documentDirectory}${path}`

    const directoryPath = `${directoryUri}/${fileName}`

    const fileInfo = await FileSystem.getInfoAsync(directoryPath)

    return fileInfo.exists
}

export const downloadSplash = async (url: string) => {
    let folderName = 'splash'
    const splashName = getSplashName(url)
    if (!splashName) {
        return
    }
    const directoryUri = `${documentDirectory}unzipped/${folderName}/`

    try {
        const splashExists = await searchSplashInFile(splashName, 'unzipped/' + folderName)
        console.log('Splash exists 2 :', splashExists)
        if (splashExists) {
            return
        } else {
            const dirInfo = await FileSystem.getInfoAsync(directoryUri)
            if (!dirInfo.exists) {
                // si no existe el directorio, lo creamos
                await FileSystem.makeDirectoryAsync(directoryUri, { intermediates: true })
                console.log('Directorio creado:', directoryUri)
            }
            console.log('Descargando splash...', dirInfo)
            const { uri } = await FileSystem.downloadAsync(url, directoryUri + splashName)
            console.log('Splash descargado en:', uri)
            return
        }
    } catch (error) {
        console.log('Error al buscar el splash en el archivo', error)
        return
    }
}
export const searchSplash = async (uri: string) => {
    const path = 'splash'
    let imageName = uri.split('/').pop()

    const directoryUri = `${documentDirectory}unzipped/${path}`

    const directoryPath = `${directoryUri}/${imageName}`

    const fileInfo = await FileSystem.getInfoAsync(directoryPath)

    let finalImage = fileInfo.exists ? fileInfo.uri : uri

    return finalImage
}

export const config2ndSplash = async (url: string, isConnected: boolean) => {
    // const { hasInternet, isConnected } = getConection()

    if (!url) {
        return null
    }
    const path = 'splash'
    const downloadDirectory = `${documentDirectory}unzipped/${path}`
    const splashName = getSplashName(url)
    console.log('Splash name:', splashName)
    const splashExists = await FileSystem.getInfoAsync(`${downloadDirectory}/${splashName}`)

    console.log('Splash exists:', splashExists)
    if (splashExists.exists) {
        return `${downloadDirectory}/${splashName}`
    } else {
        if (isConnected) {
            downloadSplash(url)
            return url
        } else {
            return null
        }
    }
}
